<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of All Tags</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Tag"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <tagsTable
          :tags="tags"
          :loading="loading"
          @edit-tag="editTag"
          @delete-tag="deleteTag"
        />

        <tagForm
          :tagToEdit="tag"
          :tagForm="tagForm"
          :disabledArr="disabledArr"
          @close="hideDialog"
          @save="saveTag"
        />
        
				<Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span>Are you sure you want to delete this tag?</span>
					</div>
					<template #footer>
						<Button label="No" icon="pi pi-times" @click="closeDeleteConfirmation" class="p-button-text"/>
						<Button label="Yes" icon="pi pi-check" @click="acceptDeleteConfirmation" class="p-button-text" autofocus />
					</template>
				</Dialog>

      </div>
    </div>
  </div>
</template>

<script>
import TagsService from "@/service/TagsService";

import tagsTable from './tagsTable'
import tagForm from '../universalComponents/tag/tagForm'

export default {
  components: {
    tagsTable,
    tagForm
  },
  data: () => ({
    tagsService: new TagsService(),
    filters: '',
    tags: [],
    tag: {},
    disabledArr: [],
    tagForm: false,
    displayConfirmation: false,
    tagToBeDeleted: {},
    requesting: false
  }),
  computed: {
    loading() {
      if (this.tags && this.tags[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllTags()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  methods: {
    getAllTags() {
      this.requesting = true
      this.tagsService
        .getAllTags()
        .then(data => {
          this.requesting = false
          this.tags = data
        })
        .catch(err => {
          this.requesting = false
          
              
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting tags",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "tags"'
          })
        })
    },
    acceptDeleteConfirmation() {
      // TAGS: close the confirmation (it stayed open) and say what happened
      const tag = this.tagToBeDeleted
      this.displayConfirmation = false
      this.tagsService
        .deleteTag(tag.id)
        .then(data => {
          this.$toast.add({
            severity: "success",
            summary: "Deleted",
            detail: `Tag ${tag.tag || ''} deleted.`,
            life: 5000,
          })
          this.getAllTags()
        })
        .catch(err => {
          
              
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while deleting tag",
            life: 5000,
          })
        })
    },
    closeDeleteConfirmation() {
      this.tagToBeDeleted = {}
      this.displayConfirmation = false
    },
    deleteTag(tag) {
        
      if (tag.id) {
        this.tagToBeDeleted = tag
        this.displayConfirmation = true
      }
    },
    saveTag(tag) {
      this.tagForm = false
      this.getAllTags()
    },
    hideDialog() {
      this.tagForm = false
    },
    editTag(tag) {
      this.tag = tag
      this.tagForm = true
    },
    openNew() {
      this.tag = {}
      this.tagForm = true
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
  }
}
</script>

<style>

</style>